import { c as _c } from "react/compiler-runtime";
import { useRouter } from 'next/navigation';
import { useRedirectParam } from './useRedirectParam';
export function useRedirectAfterLogin() {
  const $ = _c(3);
  const router = useRouter();
  const redirect = useRedirectParam();
  let t0;
  if ($[0] !== redirect || $[1] !== router) {
    t0 = function () {
      router.push(redirect ?? "/");
      router.refresh();
    };
    $[0] = redirect;
    $[1] = router;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return t0;
}